import { CaseType } from "@/App/types/caseType";

import { RouteName } from "@/App/router/routeName";

export enum CaseMode {
  ed = "emergencyDepartment",
  ift = "ift",
  mih = "mih",
}

enum DateParam {
  createdFrom = "createdFrom",
  createdTo = "createdTo",
  mihAppointmentTimeFrom = "mihAppointmentTimeFrom",
  mihAppointmentTimeTo = "mihAppointmentTimeTo",
  expectedPickupTimeFrom = "expectedPickupTimeFrom",
  expectedPickupTimeTo = "expectedPickupTimeTo",
}

export enum AppbarColor {
  ed = "#18159d",
  ift = "#006436",
  mih = "#008347",
}

export const CaseModeParams = {
  [CaseMode.ed]: {
    appbarColor: AppbarColor.ed,
    path: RouteName.cases,
    types: [CaseType.ems, CaseType.hospital],
    dateFrom: DateParam.createdFrom,
    dateTo: DateParam.createdTo,
    calendarAvailable: false,
  },
  [CaseMode.ift]: {
    appbarColor: AppbarColor.ift,
    path: RouteName.ift,
    types: [CaseType.ift],
    dateFrom: DateParam.expectedPickupTimeFrom,
    dateTo: DateParam.expectedPickupTimeTo,
    calendarAvailable: true,
  },
  [CaseMode.mih]: {
    appbarColor: AppbarColor.mih,
    path: RouteName.mih,
    types: [CaseType.mih],
    dateFrom: DateParam.mihAppointmentTimeFrom,
    dateTo: DateParam.mihAppointmentTimeTo,
    calendarAvailable: true,
  },
};
